export const socialsData = {
    github: 'https://github.com/gurdeep7',
    linkedIn: 'https://www.linkedin.com/in/gurdeep7/',
    twitter: 'https://twitter.com/gurdeep1994',

}